import React from 'react';

import { Box } from '@mui/material';

import InlineLoadingIndicator from '@common/components/loading-indicator/inline-loading-indicator';

const IframeLoadingWrapper = ({ isIframeLoaded, children }) => {
  return (
    <>
      {children}
      {!isIframeLoaded && (
        <Box
          sx={{
            display: 'flex',
            position: 'absolute',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            height: '100%'
          }}
        >
          <InlineLoadingIndicator backgroundColor="transparent" />
        </Box>
      )}
    </>
  );
};

export default IframeLoadingWrapper;
